// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { SearchDocsFiltersModule } from 'src/app/modules/search-docs/search-docs-filters.module';
import { SearchDocsRoutingModule } from './search-docs-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { SearchDocsPropertiesDialogComponent } from "src/app/modules/search-docs/components/search-docs-properties-dialog/search-docs-properties-dialog.component";
import { SearchDocsListComponent } from 'src/app/modules/search-docs/pages/search-docs-list/search-docs-list.page';
import { SearchDocsListV2Component } from 'src/app/modules/search-docs/pages/search-docs-listv2/search-docs-listv2.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    SearchDocsRoutingModule,
    // The company and supplier filters, shared with the lazy module of listv3
    SearchDocsFiltersModule,
    // PublicModule,
  ],
  declarations: [
    SearchDocsListComponent,
    SearchDocsPropertiesDialogComponent,
    SearchDocsListV2Component,
  ],
  entryComponents: [
  ],
  exports: [
    SearchDocsPropertiesDialogComponent,
    SearchDocsFiltersModule
  ]
})
export class SearchDocsModule { }
